var map = {
	"./A.png": "2ZOp",
	"./J.png": "bvHx",
	"./K.png": "IkHZ",
	"./P1.png": "+uvI",
	"./P2.png": "0QIv",
	"./P3.png": "etft",
	"./P4.png": "Os2D",
	"./Q.png": "3yxc",
	"./lot.png": "eE8f",
	"./nine.png": "Gu20",
	"./scat.png": "Yx+d",
	"./ten.png": "CE8d",
	"./wild.png": "YQAm",
	"./wild1.png": "/FpX",
	"./wild2.png": "NZcl",
	"./wild3.png": "LrHR",
	"./wild4.png": "rtbl",
	"./wild5.png": "IwVY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Odr1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb ^\.\/.*\.png$
// module id = Odr1
// module chunks = 0